import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "customer-journey-analytics-api-use-cases"
    }}>{`Customer Journey Analytics API use cases`}</h1>
    <p>{`The API use cases on this page include scenarios for using endpoints to implement various Customer Journey Analytics features.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li"><a parentName="strong" {...{
            "href": "curl.md"
          }}>{`Curl`}</a></strong>{`: Make a basic API request using Curl.`}</li>
      <li parentName="ul"><strong parentName="li"><a parentName="strong" {...{
            "href": "postman.md"
          }}>{`Postman`}</a></strong>{`: Set up an API environment in Postman to make a basic call.`}</li>
      <li parentName="ul"><strong parentName="li"><a parentName="strong" {...{
            "href": "python.md"
          }}>{`Python`}</a></strong>{`: Configure a Python environment to send an API call.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      